import React, { lazy, Suspense } from 'react';
import ProCalculatorProvider from '../contexts/ProCalculatorContext';
import { useProCalculator } from '../hooks/useProCalculator';
import ReferenceSection from './ReferenceSection';
import CookieRowsSection from './CookieRowsSection';
import SetsSection from './SetsSection';
import DimensionsSection from './DimensionsSection';
import ColorsSection from './ColorsSection';
import OrdersSection from './OrdersSection';
import ResultsSection from './ResultsSection';
import IcingPlansSection from './IcingPlansSection';
import '../styles/ProCalculator.css';

// Lazy-loaded — TensorFlow (~2 MB) only downloads if image analyzer is opened
const CookieImageAnalyzer = lazy(() => import('./CookieImageAnalyzer'));

// Inner component that uses the context
const ProCalculatorContent = () => {
  const { 
    isSectionVisible, 
    showImageAnalyzer, 
    currentAnalyzingRow, 
    setShowImageAnalyzer,
    handleImageProcessed,
    skipSets,
  } = useProCalculator();

  return (
    <div className="pro-calculator-content">
      {/* Cookie Image Analyzer Modal */}
      {showImageAnalyzer && currentAnalyzingRow && (
        <div className="modal-overlay">
          <div className="modal-content">
            <Suspense fallback={<div className="loading-screen">Loading...</div>}>
              <CookieImageAnalyzer
                onImageProcessed={handleImageProcessed}
                maxWidth={parseFloat(currentAnalyzingRow.width) || 0}
                maxLength={parseFloat(currentAnalyzingRow.length) || 0}
                onClose={() => setShowImageAnalyzer(false)}
              />
            </Suspense>
          </div>
        </div>
      )}
      
      {/* Calculator sections - We no longer need the SectionSelector here as it's in the sidebar */}
      {isSectionVisible('reference') && <ReferenceSection />}
      {isSectionVisible('cookieNames') && <CookieRowsSection />}
      {!skipSets && isSectionVisible('sets') && <SetsSection />}
      {isSectionVisible('dimensions') && <DimensionsSection />}
      {isSectionVisible('colors') && <ColorsSection />}
      {isSectionVisible('orders') && <OrdersSection />}
      {isSectionVisible('results') && <ResultsSection />}
      {isSectionVisible('icingPlans') && <IcingPlansSection />}

    </div>
  );
};

// Main component that provides the context
const ProCalculatorMain = ({ activeSection, setActiveSection, ...otherProps }) => {
  return (
    <ProCalculatorProvider 
      activeSection={activeSection} 
      setActiveSection={setActiveSection}
      {...otherProps}
    >
      <ProCalculatorContent />
    </ProCalculatorProvider>
  );
};

export default ProCalculatorMain;
